import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Drawer, Empty, Form, Input, Space } from 'antd';
import React, { useMemo, useState } from 'react';

const Attributes = ({ productDetails }) => {
  const [selectedAttribute, setSelectedAttribute] = useState({});
  const [open, setOpen] = useState(false);

  const onClose = () => {
    setOpen(false);
    setSelectedAttribute({});
  };

  const handleShowDetails = ({ attribute }) => {
    setOpen(true);
    setSelectedAttribute(attribute);
  };

  const technicalAttributes = useMemo(
    () => productDetails?.technical_attributes || [],
    [productDetails]
  );

  if (technicalAttributes.length === 0) {
    return (
      <div style={{ padding: '24px' }}>
        <Empty description="Aucun attribut technique renseigné pour ce produit" />
      </div>
    );
  }

  return (
    <div style={{ padding: '24px' }}>
      <Form layout="vertical">
        {technicalAttributes.map((attribute, index) => (
          <Form.Item key={`${attribute.name}-${index}`} label={attribute.label}>
            <Space.Compact style={{ width: '100%' }}>
              <Input
                placeholder={attribute.value}
                disabled
                style={{ width: '75%' }}
              />
              <Button
                icon={<InfoCircleOutlined />}
                onClick={() => handleShowDetails({ attribute })}
                style={{ width: '25%' }}
              >
                Détails
              </Button>
            </Space.Compact>
          </Form.Item>
        ))}
      </Form>
      <Drawer
        title="Détails"
        closable={{ 'aria-label': 'Close Button' }}
        onClose={onClose}
        open={open}
        width={500}
      >
        <Form layout="vertical">
          <Form.Item label="Variable" name="name">
            <Input placeholder={selectedAttribute?.name} disabled />
          </Form.Item>
          <Form.Item label="Libellé" name="label">
            <Input placeholder={selectedAttribute?.label} disabled />
          </Form.Item>
          <Form.Item placeholder="Description" name="description">
            <Input.TextArea
              placeholder={selectedAttribute?.description}
              disabled
              rows={4}
            />
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
};

export default Attributes;
